import { EMPTY_FIELD } from 'constants/emptyField';

import get from 'lodash/get';
import { RaRecord } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Chip } from 'shared/mui/Chips';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';

export type ArrayChipFieldProps = {
  source: string;
  optionText?: string;
  transformValue?: (v: string | number) => string | number;
  collapseToOne?: boolean;
} & Omit<FunctionFieldProps, 'render' | 'source'>;

export const ArrayChipField: React.FC<ArrayChipFieldProps> = ({
  source,
  optionText,
  collapseToOne,
  transformValue,
  ...restProps
}) => {
  return (
    <FunctionField
      render={(record: RaRecord) => {
        const values = get(record, source);

        if (!Array.isArray(values) || !values.length) {
          return EMPTY_FIELD;
        }

        const fieldValue = values.map((value: unknown) => {
          const label = optionText ? get(value, optionText) : value;

          if (typeof label === 'number') {
            return label;
          }

          return typeof label === 'string' && label ? label : EMPTY_FIELD;
        });

        if (collapseToOne) {
          return (
            <Box
              sx={{
                gap: '8px',
                display: 'flex',
              }}
            >
              <Chip label={transformValue?.(fieldValue[0]) ?? fieldValue[0]} />
              {fieldValue.length > 1 && <Chip label={`+${fieldValue.length - 1}`} />}
            </Box>
          );
        }

        return (
          <Box
            sx={{
              gap: '8px',
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {fieldValue.map((v, index) => (
              <Chip key={index} label={transformValue?.(v) ?? v} />
            ))}
          </Box>
        );
      }}
      {...restProps}
    />
  );
};
